import { ShieldCheck, Banknote, Zap, Building2 } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";

const SECTORS = [
  {
    icon: ShieldCheck,
    title: "Organismos electorales y gubernamentales",
    desc: "Soporte técnico integral para cumplir con las exigencias del CNE y las normativas nacionales de ciberseguridad.",
  },
  {
    icon: Banknote,
    title: "Sector financiero y bancario",
    desc: "Ciberseguridad bancaria, cumplimiento regulatorio y respuesta rápida ante incidentes críticos.",
  },
  {
    icon: Zap,
    title: "Energía, petróleo y misión crítica",
    desc: "Redes industriales de alta resistencia operando en Jalisco, Michoacán, Nayarit y Colima.",
  },
  {
    icon: Building2,
    title: "Grandes corporaciones del Occidente",
    desc: "Centralización de datos, infraestructura cloud y migración de plataformas legadas.",
  },
];

const Sectors = () => (
  <section id="sectores" className="scroll-mt-24 bg-obsidian py-24 sm:py-28" data-testid="sectors-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="mb-14 max-w-3xl">
        <Reveal>
          <Eyebrow>02 — Sectores y cumplimiento</Eyebrow>
          <h2 className="mt-4 font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-[2.9rem] lg:leading-[1.1]">
            Cumplimos donde el país{" "}
            <span>
              no puede fallar<span className="text-neon">.</span>
            </span>
          </h2>
          <p className="mt-5 max-w-xl font-body text-[15px] leading-relaxed text-slate-400 sm:text-base">
            Desde procesos electorales auditables hasta redes industriales de misión crítica:
            operamos bajo los estándares más estrictos que exige cada sector.
          </p>
        </Reveal>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {SECTORS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.09} className="h-full">
            <article
              data-testid={`sector-card-${i}`}
              className="group flex h-full flex-col rounded-3xl border border-white/10 bg-ink p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-neon/50 hover:shadow-[0_20px_60px_-25px_rgba(0,240,255,0.35)]"
            >
              <span className="mb-8 flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-neon transition-colors duration-500 group-hover:border-neon/50">
                <s.icon className="h-5 w-5" strokeWidth={1.6} />
              </span>
              <h3 className="font-heading text-lg font-semibold leading-snug tracking-tight text-white">
                {s.title}
              </h3>
              <p className="mt-3 font-body text-sm leading-relaxed text-slate-400">{s.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Sectors;
